import {createRoot, hydrateRoot} from 'react-dom/client';
import Footer from '../reusable_sections/Footer'
import "../index.css";

type AnyProps = Record<string, any>;

let root:
| ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
        console.log("Rendering......")
        root = createRoot(el);
        root.render(<Footer {...(props as any)}/>);
    }

function hydrate(el: HTMLElement, props: AnyProps = {}) {
    console.log("Hydrating......")
    root = hydrateRoot(el, <Footer {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).FooterVC = {mount, hydrate, unmount}